import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import Links from "common/constants/Links";
import { SCREENS } from "common/constants/Constants";
import OffersNotificationContainer from "containers/OffersNotificationContainer";

const SETTINGS_PATH = appPath(SCREENS.ACCOUNT);
const SUBSCRIPTIONS_PATH = appPath(SCREENS.SUBSCRIPTIONS);
const BILLING_HISTORY_PATH = appPath(`${ SCREENS.SUBSCRIPTIONS }?anchor_module=billing-history`);
const WATCHLIST_PATH = appPath(SCREENS.WATCHLIST);
const NEWSLETTERS_PATH = appPath(`${ SCREENS.NEWSLETTERS }?source=account_settings`);
const OFFERS_PATH = appPath(SCREENS.OFFERS);

class SideNav extends React.Component {
    constructor(props) {
        super(props);

        this._toggleDropdown = this._toggleDropdown.bind(this);
        this._logout = this._logout.bind(this);
    }

    render() {
        const navStateStyle = this.props.mobileSideNavExpanded ? "expanded" : "";
        const activePath = this.props.location.pathname;

        return (
            <div className={ "side-nav " + navStateStyle } ref="sideNav">
                <ul className="side-nav__group" ref="sideNavGroup">
                    <MenuItem
                        activePath={ activePath }
                        path={ SETTINGS_PATH }
                        title="Settings"
                        bemAddition="account"
                        linkOnClick={ () => linkOnClick(SETTINGS_PATH) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ SUBSCRIPTIONS_PATH }
                        title="Subscriptions"
                        bemAddition="subscriptions"
                        linkOnClick={ () => linkOnClick(SUBSCRIPTIONS_PATH, { refreshPage: true }) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ BILLING_HISTORY_PATH }
                        isSubMenuItem={ true }
                        title="Billing History"
                        bemAddition="billingHistory"
                        anchorBemAddition="anchorLink"
                        linkOnClick={ () => {
                            this._subLinkOnClick("#billing-history", BILLING_HISTORY_PATH);
                        } }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ OFFERS_PATH }
                        title="Offers"
                        bemAddition="offers"
                        linkOnClick={ () => linkOnClick(OFFERS_PATH) }
                    >
                        <OffersNotificationContainer />
                    </MenuItem>

                    <MenuItem
                        activePath={ activePath }
                        path={ NEWSLETTERS_PATH }
                        title="Newsletters"
                        bemAddition="newsletters"
                        linkOnClick={ () => linkOnClick(NEWSLETTERS_PATH) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ WATCHLIST_PATH }
                        title="Watchlist"
                        bemAddition="watchlist"
                        linkOnClick={ () => linkOnClick(WATCHLIST_PATH) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ this.props.bloombergSiteUrl }
                        title="Bloomberg.com"
                        bemAddition="exit"
                        linkOnClick={ () => linkOnClick(this.props.bloombergSiteUrl, { externalLink: true }) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ Links.SUBSCRIPTION_FAQ }
                        title="Help Center"
                        bemAddition="help"
                        linkOnClick={ () => linkOnClick(Links.SUBSCRIPTION_FAQ, { newTab: true }) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path={ Links.TERMINAL_CONTACT_US }
                        title="Contact Us"
                        bemAddition="contact"
                        linkOnClick={ () => linkOnClick(Links.TERMINAL_CONTACT_US, { newTab: true }) }
                    />

                    <MenuItem
                        activePath={ activePath }
                        path="#"
                        title="Sign Out"
                        bemAddition="sign-out"
                        linkOnClick={ this._logout }
                    />
                </ul>
                <button
                    className="side-nav__dropdown"
                    type="button"
                    onClick={ this._toggleDropdown }
                    ref="sideNavDropdown"
                />
            </div>
        );
    }

    _subLinkOnClick(anchorModuleSelector, anchorPath) {
        const module = document.querySelector(anchorModuleSelector);

        if (module) {
            module.scrollIntoView();
            this._toggleDropdown();

            return;
        }

        window.location = anchorPath;
    }

    _toggleDropdown() {
        this.props.mobileSideNavExpanded ? this.props.collapseMobileSideNav() : this.props.expandMobileSideNav();
    }

    _logout(event = { preventDefault() {} }) {
        event.preventDefault();
        this.props.logout(this.props.bloombergSiteUrl);
    }
}

function linkOnClick(path, { newTab = false, externalLink = false, refreshPage = false } = {}) {
    if (newTab) {
        window.open(formatPath(path), "_blank");

        return;
    }

    if (externalLink || refreshPage) {
        window.location = formatPath(path);

        return;
    }

    browserHistory.push(formatPath(path));
}

function formatPath(path) {
    const anchorlessPath = removeAnchorQueryParam(path);

    return anchorlessPath.split("?")[0];
}

function removeAnchorQueryParam(path) {
    return path.replace(/(.*)(anchor_module=.*)&(.*)/, "$1$3").replace(/(.*)(&|\?)(anchor_module=.*)$/, "$1");
}

function MenuItem({
    path,
    title,
    bemAddition,
    anchorBemAddition,
    linkOnClick: linkOnClickFunction,
    activePath,
    isSubMenuItem,
    children
}) {
    const isActiveMenuItem = !isSubMenuItem && path.indexOf(activePath) >= 0;
    const anchorSideNavClassName = `side-nav__link ${ anchorBemAddition ? "side-nav__link--" + anchorBemAddition : "" } `;
    const anchorClassName = `${ anchorSideNavClassName } ${ isActiveMenuItem ? "active" : "" }`;
    const anchorOnClick = linkOnClickFunction ? linkOnClickFunction : () => {};

    return (
        <li className={ `side-nav__item side-nav__item--${ bemAddition }` }>
            <button className={ anchorClassName } id={ bemAddition } type="button" onClick={ anchorOnClick }>
                { title }
                { children }
            </button>
        </li>
    );
}

SideNav.propTypes = {
    mobileSideNavExpanded: PropTypes.bool,
    expandMobileSideNav: PropTypes.func.isRequired,
    collapseMobileSideNav: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default SideNav;
